(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
function initGroupsetFilters(root) {
 root.querySelectorAll('[data-groupset-collection]').forEach(section => {
 const controls=section.querySelector('[data-groupset-filters]');
 if(!controls||controls.dataset.ready)return;
 controls.dataset.ready='true';controls.hidden=false;
 const selects=Array.from(controls.querySelectorAll('select[data-filter]'));
 const cards=Array.from(section.querySelectorAll('[data-groupset-card]'));
 function update(){let count=0;cards.forEach(card=>{const match=selects.every(s=>!s.value||(card.dataset[s.dataset.filter]||'').split(' ').includes(s.value));card.hidden=!match;if(match)count++;});controls.querySelector('[data-filter-count]').textContent=String(count);section.querySelector('[data-filter-empty]').hidden=count!==0;}
 selects.forEach(select=>select.addEventListener('change',update));
 controls.querySelector('[data-clear-filters]').addEventListener('click',()=>{selects.forEach(s=>s.value='');update();});
 update();
 });
}
initGroupsetFilters(document);
document.addEventListener('shopify:section:load',event=>initGroupsetFilters(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function updateProductWhatsApp() {
    const root = document.querySelector('[data-pdp]');
    if (!root) return;
    const form = root.querySelector('[data-product-form]');
    const data = form && form.querySelector('[data-product-variants]');
    if (!data) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch (error) { return; }
    const options = Array.from(form.querySelectorAll('.pdp-option input:checked')).map(input => input.value);
    const select = form.querySelector('[data-variant-select]');
    const variant = options.length ? variants.find(item => item.options.length === options.length && item.options.every((value, index) => value === options[index])) : variants.find(item => String(item.id) === String(select && select.value));
    if (!variant) return;
    const title = root.querySelector('h1').textContent.trim();
    const url = new URL(window.location.pathname, window.location.origin);
    url.searchParams.set('variant', variant.id);
    const quantity = Math.max(1, Number.parseInt(form.querySelector('[data-qty-input]')?.value, 10) || 1);
    const message = title + (variant.title === 'Default Title' ? '' : ' — ' + variant.title) + ' × ' + quantity + String.fromCharCode(10) + url.href;
    document.querySelectorAll('a[href^="https://wa.me/8618676711300"]').forEach(link => {
      link.href = 'https://wa.me/8618676711300?text=' + encodeURIComponent(message);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateProductWhatsApp, { once: true });
  else updateProductWhatsApp();
  document.addEventListener('change', function (event) {
    if (event.target.closest('[data-product-form]')) updateProductWhatsApp();
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('a[href^="https://wa.me/8618676711300"]')) updateProductWhatsApp();
  }, true);
  document.addEventListener('shopify:section:load', updateProductWhatsApp);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tooquv-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  const els=document.querySelectorAll('.tq-home [data-tq-reveal]');
  if(!els.length)return;
  const reveal=function(el){el.classList.add('is-in');};
  if(!('IntersectionObserver'in window)){els.forEach(reveal);return;}
  const io=new IntersectionObserver((entries,o)=>{
    entries.forEach(e=>{if(e.isIntersecting){reveal(e.target);o.unobserve(e.target);}});
  },{threshold:0,rootMargin:'0px 0px -8% 0px'});
  els.forEach(function(el){
    var r=el.getBoundingClientRect();
    if(r.top<window.innerHeight*0.92)reveal(el);
    else io.observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
